<dx-toolbar class="theme-dependent">
    <dxi-item location="before">
        <div class="header-text">{{ this.number ? 'Edit' : 'New' }}</div>
    </dxi-item>
    <dxi-item location="after" locateInMenu="never">
        <dx-button text="Cancel" stylingMode="outlined" type="normal" (onClick)="cancelClick.emit()" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(EmptyCheckOutAction.Save)">
        <dx-button text="Save" type="default" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(EmptyCheckOutAction.Save)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(EmptyCheckOutAction.CheckOut)">
        <dx-button text="Check Out" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(EmptyCheckOutAction.CheckOut)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never"
        [visible]="canShowButton(EmptyCheckOutAction.InvestigationCompleted)">
        <dx-button text="Investigation Completed" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(EmptyCheckOutAction.InvestigationCompleted)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(EmptyCheckOutAction.CompleteMove)">
        <dx-button text="Complete Move" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(EmptyCheckOutAction.CompleteMove)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="showMoreMenu">
        <dx-drop-down-button text="More" icon="overflow" [dropDownOptions]="{ width: 210 }" [items]="moreMenuActions"
            [splitButton]="false" stylingMode="outlined" type="default" displayExpr="text" keyExpr="id"
            [disabled]="isSubmitting" (onItemClick)="onMenuActionClick($event)" class="ms-2">
        </dx-drop-down-button>
    </dxi-item>
</dx-toolbar>